export const BrowserEvent = {
  NAVIGATE_TO_PLP: 'NAVIGATE_TO_PLP',
  MULTI_LIST_SEARCH_CLICKED: 'MULTI_LIST_SEARCH_CLICKED',
  NAVIGATE_TO_HOME: 'NAVIGATE_TO_HOME',
  FOCUS_SEARCH_BAR: 'FOCUS_SEARCH_BAR',
  FILTER_EVENT: 'FILTER_EVENT',
  FLEXI_PAGE_NAVIGATION: 'FLEXI_PAGE_NAVIGATION',
};

export const INTERNAL_TECHNICAL_ERROR = 'Internal Technical Error';

export const STORAGE_MESSAGE_TYPES = {
  GET_STORAGE: 'GET_STORAGE',
  SET_STORAGE: 'SET_STORAGE',
  REMOVE_STORAGE: 'REMOVE_STORAGE',
  GET_RESPONSE_STORAGE: 'GET_RESPONSE_STORAGE',
  SCROLL_TO_TOP: 'SCROLL_TO_TOP',
};

export const RN_MESSAGE_TYPES = {
  OPEN_BARCODE_SCANNER: 'OPEN_BARCODE_SCANNER',
};
export const STORAGE_KEYS = {
  MULTI_SEARCH_QUERIES: 'multiSearchQueries',
  IS_MULTI_SEARCH_LIST: 'isMultiSearchList',
  SELECTED_MULTI_SEARCH: 'selectedMultiSearch',
};

export const SESSION_KEYS = {
  STORE_ID: 'storeId',
};

export const COUNTRY_CODE = 'MY';
export const IS_FROM_BRANDS_AND_KEYWORD = 'isFromBrandsAndKeywords';
export const IS_FROM_PDP = 'isFromPdp';
export const PDP_QUERY = 'pdpQuery';
